export { default as SmallTextBlock } from './SmallTextBlock';
